import * as React from 'react';
import { Spinner } from 'components/Spinner';
import { prerenderedLoadable } from 'utils/prefetch';
const SecurityPage = prerenderedLoadable(() => import(/* webpackChunkName: "Security" */ 'containers/Content/Security/Security'));
export const Security = () => (React.createElement(React.Suspense, { fallback: React.createElement(Spinner, null) },
    React.createElement(SecurityPage, null)));
